module.exports = __webpack_public_path__ + "img/03.37b70766.png";